import React from "react";
import { finApi, money } from "@/lib/financeApi";
import { Empty, ErrorBox, Loading, useLoad } from "@/components/nds/windows/finance/parts";
import { TxTable } from "@/components/nds/windows/finance/OutsideIncomeTab";

export default function PenaltyHistoryTab({ resident }) {
  const [state, load] = useLoad(() => Promise.all([
    finApi.get(`/residents/${resident.id}/balances`),
    finApi.get(`/residents/${resident.id}/ledger`, { bucket: "penalty", page_size: 200 }),
  ]).then(([b, l]) => ({ balance: b.balances.penalty, items: l.items, total: l.total })), [resident.id]);

  if (state.loading && !state.data) return <Loading testid="fin-penalty-history-loading" />;
  if (state.error) return <ErrorBox testid="fin-penalty-history-error" error={state.error} onRetry={load} />;
  const owed = Math.max(-state.data.balance, 0);
  return (
    <div data-testid="fin-penalty-history-tab" className="p-5 space-y-3">
      <div className="flex items-center justify-between px-4 py-3 border border-white/10 rounded-sm">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Outstanding penalty balance</span>
        <span data-testid="fin-penalty-history-owed" className={`font-mono text-lg ${owed > 0 ? "text-red-300" : "text-nex-muted"}`}>{money(owed)}</span>
      </div>
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Penalty bucket audit trail · {state.data.total} rows</div>
      {state.data.items.length ? <TxTable testid="fin-penalty-history" items={state.data.items} /> : <Empty testid="fin-penalty-history-empty">No penalty activity yet.</Empty>}
    </div>
  );
}
